module.exports = {
  CREATED: 'created',
  PENDING: 'pending',
  ACTIVATED: 'activated',
  CANCELLING: 'cancelling',
  CANCELLED: 'cancelled',
};
